import React from 'react'
import Button from './../../Button'
import injectStyles from 'react-jss'
import classNames from 'classnames'

const styles = {
  button: {
    width: 100,
    height: 22,
    boxSizing: 'border-box',
    fontSize: 12,
    padding: 0,
    margin: 5,
    opacity: 0.5,
  },
  active: {
    opacity: 1,
  },
}

const RadioButtons = ({ values, value, onChange, classes }) => <div>
  {values.map(val =>
    <Button
      className={classNames({
        [classes.button]: true,
        [classes.active]: val == value,
      })}
      onClick={() => onChange(val)}
    >{val}</Button>)}
</div>

export default injectStyles(styles)(RadioButtons)


// WEBPACK FOOTER //
// ./src/modules/ControlWrapper/SettingsIcon/RadioButtons.js